.root {
    background-color: var(--off-white);
}

.resultsPage {
    composes: container from "./composable/layout.module.css";
    padding-block: var(--spacer-40);
}
